import { FiX } from "react-icons/fi";
import { MdDragIndicator } from "react-icons/md";
import { DesktopPanelResizeCorners } from "@/features/thread/components/desktop/DesktopPanelResizeCorners";
import { ThreadCreateForm } from "@/features/thread/components/forms/ThreadCreateForm";
import { useDraggablePanel } from "@/shared/hooks";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const PANEL_HEADING_ID = "desktop-thread-create-heading";

/** デスクトップ版の移動・サイズ変更可能な新規スレッドフォーム。 */
export const DesktopThreadCreatePanel: React.FunctionComponent<Props> = ({
  isOpen,
  onClose,
}: Props) => {
  // 開閉タブを持たないため、ドラッグ境界は常に展開状態の寸法で計算する。
  const { panelRef, panelStyle, handleProps, resizeHandleProps } =
    useDraggablePanel({ persistKey: "thread-create" });

  return (
    <aside
      ref={panelRef}
      style={panelStyle}
      className="desktop-floating-panel desktop-thread-create-panel"
      data-kind="thread"
      data-open={isOpen}
      aria-hidden={!isOpen}
      aria-labelledby={PANEL_HEADING_ID}
    >
      <header className="desktop-thread-create-heading" {...handleProps}>
        <MdDragIndicator aria-hidden="true" />
        <h2 id={PANEL_HEADING_ID}>新規スレッド</h2>
        <button
          type="button"
          aria-label="新規スレッドフォームを閉じる"
          onPointerDown={(event: React.PointerEvent<HTMLButtonElement>): void =>
            event.stopPropagation()
          }
          onClick={onClose}
        >
          <FiX aria-hidden="true" />
        </button>
      </header>
      <ThreadCreateForm
        className="desktop-floating-form"
        active={isOpen}
        showDesktopLabels
        onSuccess={(): void => {
          onClose();
        }}
      />
      <DesktopPanelResizeCorners
        panelLabel="新規スレッドフォーム"
        handleProps={resizeHandleProps}
      />
    </aside>
  );
};
